/**
 * Route Loading Fallback Component
 * 
 * A consistent, branded loading state for route-level lazy loading.
 * Used in Suspense boundaries for route code splitting.
 */

import React from 'react';

interface RouteLoadingFallbackProps {
  message?: string;
  fullScreen?: boolean;
}

export const RouteLoadingFallback: React.FC<RouteLoadingFallbackProps> = ({
  message = 'Loading page...',
  fullScreen = true,
}) => {
  const containerClass = fullScreen
    ? 'flex min-h-screen w-full items-center justify-center bg-gray-50 px-4'
    : [
        // Fill the visible content pane below app chrome (navbar / seller header).
        'flex w-full items-center justify-center px-4',
        'min-h-[calc(100dvh-3.5rem)]',
        'sm:min-h-[calc(100dvh-3.5rem)]',
        'md:min-h-[calc(100dvh-4rem)]',
      ].join(' ');

  return (
    <div className={containerClass} role="status" aria-live="polite" aria-busy="true">
      <div className="text-center">
        <div className="relative mx-auto mb-3 inline-block sm:mb-4">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-purple-200 border-t-purple-600 sm:h-12 sm:w-12" />
        </div>
        <p className="text-sm font-medium text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default RouteLoadingFallback;

